<template>
    <div class="container mescroll-touch">
        <div class="topdh" @click="back"><img src="../../assets/images/bjback.png" class="homeimg" />首页&nbsp;>&nbsp;专家日程
        </div>
        <div class="total">
            <div class="rclist">
                <div class="toptip">
                    <div class="topback">
                        <div class="day">{{ list.DateStr2 }}</div>
                        <div class="tprow">
                            <div class="time"><img src="../../assets/images/dttime.png" class="icon" /><span>{{
                                list.StartTimeStr }} - {{ list.EndTimeStr }}</span></div>
                            <div class="address"><img src="../../assets/images/dtadd.png" class="icon1" /><span>{{
                                list.Address }}</span></div>
                        </div>
                        <div class="title">{{ list.Title }}</div>
                    </div>
                    <div class="topnoback">
                        <div class="nbrow">
                            <div class="zjzw">主席</div>
                        </div>
                        <div class="nbrow" v-for="(item, index) in list.Chairman" :key="index"
                            @click="openlist(item.ExpertId)">
                            <div class="zjtouxiang">
                                <img v-if="item.HeadUrl" :src="item.HeadUrl" class="tximg" />
                                <img v-else src="../../assets/images/nonehead.png" class="tximg" />
                            </div>
                            <div class="namerow">
                                <div class="zjname" v-if="item.JobTitle">{{ item.Name }}&nbsp;{{ item.JobTitle }}</div>
                                <div class="zjname" v-else>{{ item.Name }}</div>
                                <div class="zjhos">{{ item.Hospital }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tips" v-for="(item, index) in list.Detail" :key="index">
                    <div class="tipstop">
                        <img src="../../assets/images/customline.png" class="tipspoint" />
                        <span class="tipstime">{{ item.StartTimeStr }} - {{ item.EndTimeStr }}</span>
                    </div>
                    <div class="tipsmain">
                        <div class="topnoback1">
                            <div class="nbrow1 nbtit">
                                {{ item.Title }}
                            </div>

                            <!-- <div class="nbrow1" v-for="(iitem, index) in item.Talker" :key="index"
                                @click="openlist(iitem.ExpertId)">
                                <div class="zjtouxiang">
                                    <img v-if="iitem.HeadUrl" :src="iitem.HeadUrl" class="tximg" />
                                    <img v-else src="../../assets/images/nonehead.png" class="tximg" />
                                </div>
                                <div class="namerow">
                                    <div class="zjname">{{ iitem.Name }}</div>
                                    <div class="zjhos">{{ iitem.Hospital }}</div>
                                </div>
                            </div> -->

                            <!-- 嘉宾组 TalkerType=1 -->
                            <div v-if="item.Talker.some(t => t.TalkerType === 1)">
                                <div class="nbrow1 zjzw">发言嘉宾</div>
                                <div class="nbrow1"
                                    v-for="(iitem, index) in item.Talker.filter(t => t.TalkerType === 1)" :key="index"
                                    @click="openlist(iitem.ExpertId)">
                                    <div class="zjtouxiang">
                                        <img v-if="iitem.HeadUrl" :src="iitem.HeadUrl" class="tximg" />
                                        <img v-else src="../../assets/images/nonehead.png" class="tximg" />
                                    </div>
                                    <div class="namerow">
                                        <div class="zjname" v-if="iitem.Mission">{{ iitem.Name }}&nbsp;{{ iitem.Mission
                                        }}</div>
                                        <div class="zjname" v-else>{{ iitem.Name }}</div>
                                        <div class="zjhos">{{ iitem.Hospital }}</div>
                                    </div>
                                </div>
                            </div>

                            <!-- 主持人组 TalkerType=2 -->
                            <div v-if="item.Talker.some(t => t.TalkerType === 2)">
                                <div class="nbrow1 zjzw">主持人</div>
                                <div class="nbrow1"
                                    v-for="(iitem, index) in item.Talker.filter(t => t.TalkerType === 2)" :key="index"
                                    @click="openlist(iitem.ExpertId)">
                                    <div class="zjtouxiang">
                                        <img v-if="iitem.HeadUrl" :src="iitem.HeadUrl" class="tximg" />
                                        <img v-else src="../../assets/images/nonehead.png" class="tximg" />
                                    </div>
                                    <div class="namerow">
                                        <div class="zjname" v-if="iitem.Mission">{{ iitem.Name }}&nbsp;{{ iitem.Mission
                                            }}</div>
                                        <div class="zjname" v-else>{{ iitem.Name }}</div>
                                        <div class="zjhos">{{ iitem.Hospital }}</div>
                                    </div>
                                </div>
                            </div>

                            <!-- 讲者组 TalkerType=3 -->
                            <div v-if="item.Talker.some(t => t.TalkerType === 3)">
                                <div class="nbrow1 zjzw">讲者</div>
                                <div class="nbrow1"
                                    v-for="(iitem, index) in item.Talker.filter(t => t.TalkerType === 3)" :key="index"
                                    @click="openlist(iitem.ExpertId)">
                                    <div class="zjtouxiang">
                                        <img v-if="iitem.HeadUrl" :src="iitem.HeadUrl" class="tximg" />
                                        <img v-else src="../../assets/images/nonehead.png" class="tximg" />
                                    </div>
                                    <div class="namerow">
                                        <div class="zjname" v-if="iitem.Mission">{{ iitem.Name }}&nbsp;{{ iitem.Mission
                                        }}</div>
                                        <div class="zjname" v-else>{{ iitem.Name }}</div>
                                        <div class="zjhos">{{ iitem.Hospital }}</div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <!-- <img src="../../assets/images/bjfooter.png" class="footerimg" /> -->
        </div>
        <div class="tankuangout" v-if="showlist == 1">
            <div class="tankuangback" @click="showlist = 0"></div>
            <div class="tankuangmain" ref="wrapper">
                <div class="tktop">
                    <div class="tktopleft">
                        <div class="txout">
                            <img :src="docinnerlist.ExpertHead" alt="" class="lefttouxiang" />
                        </div>
                    </div>
                    <div class="tktopright">
                        <div class="tkname">{{ docinnerlist.ExpertName }}</div>
                        <div class="tkhos">{{ docinnerlist.ExpertHospital }}</div>
                    </div>
                </div>
                <div class="tkinnerrow" v-for="(item, index) in docinnerlist.Schedule" :key="index"
                    @click="gomeeting(item.ActivityScheduleId)">
                    <div class="tkdayrow">
                        <span class="day"><img src="../../assets/images/tkday.png" class="tkimg" /><span>{{
                            item.DateStr
                                }}</span></span>
                    </div>
                    <div class="tkxueshurow" v-if="item.Mission">学术任务：{{ item.Mission }}</div>
                    <div class="tkxueshurow" v-else>学术任务：暂无</div>
                    <div class="tkkhrow">【{{ item.Theme }}】</div>
                    <div class="tktitlerow">{{ item.Title }}</div>
                    <div class="tktime"><img src="../../assets/images/tktime.png" class="tkimg" /><span>{{
                        item.StartTimeStr }} - {{ item.EndTimeStr }}</span></div>
                    <div class="tkpos"><img src="../../assets/images/tkpos.png" class="tkimg" /><span>{{
                        item.Address
                            }}</span></div>
                    <div class="tkopen">查看详情<span class="s1">></span><span class="s2">></span><span class="s3">></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="backbtn" @click="back()">
            <img src="../../assets/images/backicon.png" alt="">
        </div>
    </div>
</template>

<script>
import mixin from '../../common/mixin/mixins'
import BScroll from 'better-scroll'
export default {
    name: 'custommeeting',
    data() {
        return {
            Id: this.$route.query.Id,
            list: [],
            showlist: 0
        }
    },
    mixins: [mixin],
    created() {
        this.initbjShare();
        this.getdate()
        document.title = "日程信息";
    },
    mounted() {
        this.initDrag();
    },
    methods: {
        getdate() {
            let that = this;
            this.$axios.get('/api/api/web/activity/GetSceduleDetail?id=' + that.Id).then(res => {
                that.list = res.Data;
                console.log(res.Data)
                // for (var d = 0; d < that.list.Detail.length; d++) {
                //     that.list.Detail[d].hasjb = false;
                //     that.list.Detail[d].haszcr = false;
                //     that.list.Detail[d].hasjz = false;
                //     for (var i = 0; i < that.list.Detail[d].Talker.length; i++) {
                //         // console.log(res.Data.Detail[d].Talker[i].TalkerType)
                //         let dtext = that.list.Detail[d].Talker[i]
                //         if (dtext.TalkerType == 1) {
                //             that.list.Detail[d].hasjb = true
                //         }
                //         if (dtext.TalkerType == 2) {
                //             that.list.Detail[d].haszcr = true
                //         }
                //         if (dtext.TalkerType == 3) {
                //             that.list.Detail[d].hasjz = true
                //         }
                //         console.log(this.list)
                //     }
                // }

            })
        },
        initBScroll() {
            this.$nextTick(() => {
                this.scroll = new BScroll(this.$refs['wrapper'], {
                    startX: 0,
                    click: true,
                    scrollX: false,
                    scrollY: true,
                    // eventPassthrough: 'vertical'
                })
            })
        },
        openlist(i) {
            let that = this;
            this.$router.push({
                path: 'customzj',
                query: {
                    Id: i,
                    ActivityId: this.$route.query.ActivityId
                }
            });
            // that.docinnerlist = [];
            // console.log(i)
            // this.$axios.get('/api/api/web/activity/GetScheduleByExpert?expertId=' + i + '&ActivityId=' + this.$route.query.ActivityId).then(res => {
            //     if (res.RetCode == "10000") {
            //         // console.log(res.Data.Url)
            //         that.docinnerlist = res.Data;
            //         console.log(that.docinnerlist)
            //         that.showlist = 1
            //         // that.imgurl = res.Data.Url
            //         this.initBScroll()
            //     }
            // });
        },
        gomeeting(id) {
            this.$router.push({
                path: 'custommeeting',
                query: {
                    Id: id,
                    ActivityId: this.$route.query.ActivityId
                }
            });
        },
        back() {
            this.$router.replace({
                path: "custom",
                query: {
                    Id: this.$route.query.ActivityId,
                },
            });
        },
        initDrag() {
            const btn = document.querySelector('.backbtn');
            if (!btn) return;

            // 触摸开始（移动端）
            btn.addEventListener('touchstart', (e) => {
                this.isDragging = true;
                // 获取初始触摸位置
                this.startX = e.touches[0].clientX;
                this.startY = e.touches[0].clientY;
                // 获取按钮当前位置
                const rect = btn.getBoundingClientRect();
                this.btnX = rect.left;
                this.btnY = rect.top;
                // 阻止默认行为
                // e.preventDefault();
            });

            // 触摸移动（移动端）
            btn.addEventListener('touchmove', (e) => {
                if (!this.isDragging) return;
                // 计算移动距离
                const moveX = e.touches[0].clientX - this.startX;
                const moveY = e.touches[0].clientY - this.startY;
                // 设置按钮新位置
                btn.style.left = `${this.btnX + moveX}px`;
                btn.style.top = `${this.btnY + moveY}px`;
                // 清除原有right/transform
                btn.style.right = 'auto';
                btn.style.transform = 'none';
                e.preventDefault();
            });

            // 触摸结束（移动端）
            btn.addEventListener('touchend', () => {
                this.isDragging = false;
            });

            // 兼容PC端鼠标操作
            btn.addEventListener('mousedown', (e) => {
                this.isDragging = true;
                this.startX = e.clientX;
                this.startY = e.clientY;
                const rect = btn.getBoundingClientRect();
                this.btnX = rect.left;
                this.btnY = rect.top;
                e.preventDefault();
            });

            document.addEventListener('mousemove', (e) => {
                if (!this.isDragging) return;
                const moveX = e.clientX - this.startX;
                const moveY = e.clientY - this.startY;
                btn.style.left = `${this.btnX + moveX}px`;
                btn.style.top = `${this.btnY + moveY}px`;
                btn.style.right = 'auto';
                btn.style.transform = 'none';
            });

            document.addEventListener('mouseup', () => {
                this.isDragging = false;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
body {
    -webkit-overflow-scrolling: unset
}

.container {
    min-height: 100%;
    width: 100%;
    position: relative;
    -webkit-overflow-scrolling: unset; // background: rgb(228, 236, 255);
    background: rgb(228, 236, 255);

}

.total {
    position: relative;
    height: 100%;
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.guanggaoimg {
    display: block;
    width: 90%;
    margin: 0.5rem auto;
}

.footerimg {
    display: block;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1;
}

.topdh {
    font-family: cursive;
    font-weight: bold;
    background-image: linear-gradient(to right, #01B671, #2D5EAA);
    color: #fff;
    padding: 0.3rem;
}

.homeimg {
    width: 5%;
    display: inline-block;
    vertical-align: text-bottom;
    margin-right: 0.1rem;
}

.mainimg {
    width: 100%;
    position: relative;
    z-index: 100;
    margin-bottom: 1.8rem;
}

.titletime {
    text-align: center;
    background-image: linear-gradient(to right, #1DA4BA, #2D5EAB);
    color: #fff;
    font-size: .5rem;
    padding: 0.2rem 0;
}

.innerlist {
    display: flex;
    flex-direction: row;
    padding: 0.4rem 0.5rem;
}

.innerlist:nth-child(odd) {
    background-color: #fff;
}

.innerlist:nth-child(even) {
    background-color: #E9F0F8;
}

.dateleft {
    display: flex;
    flex-direction: column;
    font-family: cursive;
    font-weight: bold;
    width: 90%;
    margin-right: 3%;
}

.dataright {
    width: 7%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.tarow {
    display: flex;
    flex-direction: row;
    font-size: .36rem;
    color: #9b9b9b;
}

.lefttitle {
    margin-bottom: .1rem;
    color: #3866AD;
    font-size: .43rem;
}

.lefttime {
    margin-right: .5rem;
}

.dtjt {
    display: block;
    width: 90%;
    margin: auto;
}

.rclist {
    padding-bottom: 2rem;
}

.toptip {
    width: 85%;
    margin: auto;
    box-shadow: 0 0 0.24rem 0.026667rem rgba(0, 0, 0, 0.2);
    background: #fff;
    z-index: 100;
    position: relative;
    border-radius: 0.5rem;
    box-sizing: border-box;
    margin-top: 0.5rem;
    overflow: hidden;
}

.topback {
    background: #003583;
    padding: 0.4rem;
    color: #fff;
}

.topnoback {
    padding: 0.4rem;
    background-image: linear-gradient(to bottom, #fff, #e5e7e8);
}

.day {
    font-size: .6rem;
}

.icon {
    width: 10%;
    display: block;
    margin-right: 0.15rem;
}

.icon1 {
    width: 5%;
    display: block;
    margin-right: 0.15rem;
}

.time {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 35%;
}

.address {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 65%;
}

.tprow {
    display: flex;
    flex-direction: row;
    font-size: .32rem;
    margin: .2rem 0;
}

.nbrow {
    display: flex;
    flex-direction: row;
    margin-bottom: 0.3rem;
}

.zjtouxiang {
    width: 1.3rem;
    height: 1.3rem;
    position: relative;
    overflow: hidden;
    border-radius: 50rem;
    margin-right: 0.3rem;
}

.tximg {
    display: block;
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.namerow {
    width: 76%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.zjname {
    font-size: .45rem;
    margin-bottom: 0.1rem;
    font-weight: bold;
}

.zjhos {
    font-size: .37rem;
}

.nbrow1 {
    display: flex;
    flex-direction: row;
    margin-bottom: 0.3rem;
}

.tips {
    width: 85%;
    margin: auto;
    margin-top: 0.5rem;
    position: relative;
}

.tipspoint {
    display: inline-block;
    width: 4%;
    vertical-align: middle;
    margin-right: 0.15rem;
}

.tipstime {
    vertical-align: middle;
}

.tipsmain {
    border-left: 1px solid #003583;
    margin-left: 0.15rem;
    margin-top: 0.1rem;
}

.topnoback1 {
    width: 93%;
    margin: auto;
    box-shadow: 0 0 0.24rem 0.02667rem rgba(0, 0, 0, 0.2);
    background: #fff;
    z-index: 100;
    position: relative;
    border-radius: 0.5rem;
    box-sizing: border-box;
    margin-top: 0.4rem;
    overflow: hidden;
    padding: 0.3rem;
    background-image: linear-gradient(to bottom, #fff, #e5e7e8);
}

.nbtit {
    font-size: .45rem;
    color: #003583;
    font-weight: bold;
}

.topdh {
    font-family: cursive;
    font-weight: bold;
    background: #003583;
    color: #fff;
    padding: 0.3rem;
}

.homeimg {
    width: 5%;
    display: inline-block;
    vertical-align: text-bottom;
    margin-right: 0.1rem;
}

.tankuangout {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999999;
}

.tankuangback {
    width: 100%;
    height: 100%;
    z-index: 50;
    position: relative;
    background: rgba(0, 0, 0, 0.5);
}

.tankuangmain {
    width: 90%;
    position: absolute;
    background: #fff;
    left: 50%;
    transform: translateX(-50%);
    top: 1rem;
    z-index: 55;
    border-radius: 0.5rem;
    overflow-y: scroll;
    height: 90%;
    -webkit-overflow-scrolling: touch;
}

.tktop {
    display: flex;
    flex-direction: row;
    width: 100%;
    background-image: linear-gradient(to bottom, #1FA1BB, #277EB3);
    padding: 0.4rem 0;
}

.tktopleft {
    width: 25%;
}

.tktopright {
    width: 75%;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}

.lefttouxiang {
    width: 100%;
    display: block;
    margin: auto;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.txout {
    width: 1.7rem;
    height: 1.7rem;
    border-radius: 50rem;
    overflow: hidden;
    position: relative;
    margin: auto;
    background: #fff;
}

.tkname {
    font-size: .55rem;
    font-weight: bold;
}

.tkinnerrow {
    padding: 0.4rem 0;
    width: 85%;
    border-bottom: 1px solid #2781B5;
    margin: auto;
    color: #2781B5
}

.day {
    // background: #2781B5;
    color: #fff;
    padding: 0 0.1rem;
}

.tkdayrow {
    margin-bottom: 0.2rem;
}

.tkxueshurow {
    margin-bottom: 0.1rem;
}

.tkkhrow {
    margin-bottom: 0.1rem;
}

.tktitlerow {
    margin-bottom: 0.3rem;
}

.tktime {
    margin-bottom: 0.3rem;
}

.tkpos {
    margin-bottom: 0.3rem;
}

.tkopen {
    text-align: right;
    color: #8f8f8f;
}

.s1 {
    font-family: cursive;
    font-weight: bold;
    margin-left: 0.1rem;
    vertical-align: middle;
}

.s2 {
    font-family: cursive;
    font-weight: bold;
    vertical-align: middle;
    color: #c2c2c2;
}

.s3 {
    font-family: cursive;
    font-weight: bold;
    vertical-align: middle;
    color: #dddcdc;
}

.tkimg {
    width: .34rem;
    transform: translateY(0.025rem);
    margin-right: 0.1rem;
}

.backbtn {
    width: 13%;
    position: fixed;
    right: 0;
    top: 50%;
    opacity: .8;
    transform: translateY(-50%);
    z-index: 99999;
    /* 新增拖动相关样式 */
    touch-action: none;
    /* 禁用浏览器默认触摸行为 */
    user-select: none;
    /* 防止拖动时选中文字 */
    -webkit-user-drag: element;
    /* 开启移动端拖动 */
    cursor: move;
    /* 鼠标指针提示可拖动 */
    transition: transform 0.1s ease;
    /* 拖动过渡更顺滑 */
}

.backbtn:active {
    opacity: 1;
    /* 拖动时提高透明度，增强反馈 */
    transform: translateY(-50%) scale(1.05);
    /* 拖动时轻微放大，提升体验 */
}

.backbtn img {
    width: 100%;
    pointer-events: none;
    /* 让拖动事件穿透到父元素 */
}

.title {
    font-weight: bold;
    font-size: .5rem;
}

.zjzw {
    display: inline-block;
    padding: 0 0.2rem;
    border-radius: 0.1rem;
}
</style>